import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  template: `
    <footer class="bg-stone-900 text-white py-20 px-8 lg:px-32">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-16">
        <div class="col-span-1 md:col-span-1">
          <h2 class="font-serif text-2xl text-gold-accent mb-6">Regency House Cleaning</h2>
          <p class="text-stone-400 text-sm leading-relaxed">
            We send more than just a cleaning crew; we send highly trained professionals who truly care for your space.
          </p>
        </div>
        <div>
          <h4 class="font-sans font-bold text-sm uppercase tracking-widest mb-6">Company</h4>
          <ul class="space-y-4 text-stone-400 text-sm">
            <li><a class="hover:text-gold-accent transition-colors cursor-pointer" routerLink="/about">About Us</a></li>
            <li><a class="hover:text-gold-accent transition-colors cursor-pointer" routerLink="/services">Certifications &amp; Services</a></li>
            <li><a class="hover:text-gold-accent transition-colors cursor-pointer" routerLink="/senior-independence">Senior Independence Care</a></li>
            <li><a class="hover:text-gold-accent transition-colors cursor-pointer" routerLink="/team">Our Specialists</a></li>
            <li><a class="hover:text-gold-accent transition-colors cursor-pointer" routerLink="/affiliates">Partner Program</a></li>
            <li><a class="hover:text-gold-accent transition-colors cursor-pointer" routerLink="/affiliates/terms">Payout Terms</a></li>
            <!-- <li><a class="hover:text-gold-accent transition-colors cursor-pointer" routerLink="/analytics">Internal Analytics</a></li> -->
            <li><a class="hover:text-gold-accent transition-colors cursor-pointer" routerLink="/privacy">Privacy Policy</a></li>
          </ul>
        </div>
        <div>
          <h4 class="font-sans font-bold text-sm uppercase tracking-widest mb-6">Contact &amp; Location</h4>
          <ul class="space-y-4 text-stone-400 text-sm">
            <li class="flex items-center gap-2"><span class="material-symbols-outlined text-sm">mail</span>info@regencyhousecleaning.com</li>
            <li class="flex items-center gap-2 font-bold text-white"><span class="material-symbols-outlined text-gold-accent text-base">call</span> <a href="tel:6463053661" class="hover:text-gold-accent transition-colors">(646) 305-3661</a></li>
            <li class="flex items-start gap-2">
              <span class="material-symbols-outlined text-gold-accent text-sm mt-0.5">location_on</span>
              <span>Exclusively Serving New York City<br/><span class="text-xs text-stone-500">Manhattan • Brooklyn • Queens</span></span>
            </li>
          </ul>
        </div>
        <div>
          <!-- <h4 class="font-sans font-bold text-sm uppercase tracking-widest mb-6">Newsletter</h4>
          <div class="flex gap-2">
            <input class="bg-stone-800 border-none rounded px-4 py-3 text-sm flex-1 focus:ring-2 focus:ring-gold-accent" placeholder="Email Address" type="email"/>
            <button class="bg-gold-accent text-black p-3 rounded hover:bg-amber-400 transition-colors">
              <span class="material-symbols-outlined">arrow_forward</span>
            </button> 
          </div>-->
        </div>
      </div>
      <div class="mt-20 pt-8 border-t border-stone-800 flex flex-col md:flex-row justify-between items-center gap-6">
        <p class="text-stone-500 text-xs uppercase tracking-[0.2em]">© 2026 Regency House Cleaning Professional Services. All rights reserved.</p>
        <div class="flex gap-8">
          <span class="material-symbols-outlined text-stone-500 hover:text-white cursor-pointer">public</span>
          <span class="material-symbols-outlined text-stone-500 hover:text-white cursor-pointer">verified_user</span>
          <span class="material-symbols-outlined text-stone-500 hover:text-white cursor-pointer">workspace_premium</span>
        </div>
      </div>
    </footer>

    <!-- BottomNavBar (Mobile Only) -->
    <div class="md:hidden fixed bottom-0 left-0 w-full z-50 flex justify-around items-center bg-white dark:bg-stone-950 pb-safe pt-2 min-h-[88px] border-t-2 border-stone-200 dark:border-stone-800 shadow-[0_-4px_20px_rgba(0,0,0,0.05)]">
      <div class="flex flex-col items-center justify-center text-stone-500 dark:text-stone-400 py-3 px-6 cursor-pointer" routerLink="/">
        <span class="material-symbols-outlined">home</span>
        <span class="font-serif text-sm font-medium">Home</span>
      </div>
      <div class="flex flex-col items-center justify-center text-stone-500 dark:text-stone-400 py-3 px-6 cursor-pointer" routerLink="/services">
        <span class="material-symbols-outlined">verified</span>
        <span class="font-serif text-sm font-medium">Services</span>
      </div>
      <div class="flex flex-col items-center justify-center text-stone-500 dark:text-stone-400 py-3 px-6 cursor-pointer" routerLink="/book">
        <span class="material-symbols-outlined">calendar_month</span>
        <span class="font-serif text-sm font-medium">Book Now</span>
      </div>
      <div class="flex flex-col items-center justify-center text-stone-500 dark:text-stone-400 py-3 px-6 cursor-pointer" routerLink="/portal">
        <span class="material-symbols-outlined">person</span>
        <span class="font-serif text-sm font-medium">My Portal</span>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }
  `],
})
export class FooterComponent { }
